import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { LOANS_ROUTING_PARAMS, LoansPaths } from 'app/configs/routesConfig/loans';

import { LoanApplicationTabRouteParam } from 'constants/loanApplication';

import { getApplicationIdFromChannelId } from '../TeamChat.utils';

const useOpenLoanApplicationFromChat = ({ chatId, onBeforeNavigate = null }) => {
  const history = useHistory();

  const applicationId = getApplicationIdFromChannelId(chatId);

  const onOpen = useCallback(
    e => {
      e?.stopPropagation?.();

      if (!applicationId) {
        return;
      }

      const pathname = LoansPaths.applicationManagement.generatePath({
        [LOANS_ROUTING_PARAMS.applicationId]: applicationId,
        [LOANS_ROUTING_PARAMS.tab]: LoanApplicationTabRouteParam.ACTIVITIES,
      });

      if (onBeforeNavigate) {
        onBeforeNavigate();
      }

      history.push(pathname);
    },
    [history, applicationId, onBeforeNavigate],
  );

  return { applicationId, onOpen };
};

export default useOpenLoanApplicationFromChat;
